import { gql } from "@apollo/client";

export const EXIST_CODIGO_SAP = gql`
query existCodigoSap($idPlanCuidado : Int, $codigoSap: String!, $clientes: [String!]){
    existCodigoSap(idPlanCuidado: $idPlanCuidado, codigoSap: $codigoSap, clientes: $clientes)  
    }
`;